import * as React from "react";

function SvgComponent(props) {
  return (
    <svg width={"100%"} viewBox="0 0 494.53 420.25" {...props}>
      <defs>
        <linearGradient
          id="servicesbackground__linear-gradient"
          x1={125.59}
          y1={324.42}
          x2={125.59}
          y2={293.42}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.01} stopColor="#fff" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="servicesbackground__linear-gradient-2"
          x1={395.4}
          y1={267.18}
          x2={405.65}
          y2={267.18}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#572727" />
          <stop offset={1} stopColor="#451111" />
        </linearGradient>
        <linearGradient
          id="servicesbackground__linear-gradient-3"
          x1={-2295.58}
          y1={98.88}
          x2={-2284.67}
          y2={98.88}
          gradientTransform="matrix(-1 0 0 1 -2015.76 0)"
          xlinkHref="#servicesbackground__linear-gradient"
        />
      </defs>
      <g id="servicesbackground__Layer_2" data-name="Layer 2">
        <g id="servicesbackground__Layer_1-2" data-name="Layer 1">
          <path
            d="M248.44 191.2c62.65-.71 116.06 20.76 135.33 51.16 5-3.4 9.92-6.88 14.61-10.66-27.48-29-83.47-48.48-147.89-47.75-56.79.65-106.68 16.84-136 41a101.77 101.77 0 004.51 13.87c21.68-27.42 71.36-46.96 129.44-47.62z"
            fill="#ef0e0e"
          />
          <path
            d="M248.44 188c64.22-.73 118.74 21.84 136.73 53.45 5.13-3.52 10.19-7.12 14.95-11.1-26.82-30-83.84-50.35-149.63-49.6-57.17.65-107.34 17.06-136.62 41.45a97 97 0 004.23 14.51c21.22-28.05 71.49-48.09 130.34-48.71z"
            fill="#f56a6a"
          />
          <path
            d="M251.93 176c62.56-.71 118 15.57 151.85 41.05 2.58-2.27 5.16-4.55 7.76-6.81-37.39-24.51-94.26-39.82-157.81-39.1-61.9.7-117.1 16.48-153.92 40.74 1.21 2.25 2.51 4.44 3.9 6.59C137.13 193.34 191 176.69 251.93 176z"
            fill="#ef0e0e"
          />
          <path
            d="M251.93 173.45c63.52-.72 119.76 16.07 153.41 42.22l7.85-6.86c-37.36-25.16-95-40.95-159.46-40.22-62.45.71-118.08 16.75-154.9 41.37 1.16 2.34 2.44 4.6 3.81 6.8 33.36-25.58 87.67-42.61 149.29-43.31z"
            fill="#f56a6a"
          />
          <g id="servicesbackground__globe1">
            <path
              d="M358.61 242.65c-1.37 5.52-3.6 10.84-3.83 16.62-.17 4.58-1.26 8-3.67 10.62-.93 1-3.54 0-4.52-1.51-1.54-2.38 1-7.13-2-7.73-3.75-.74-5.85 0-7.19 4.91-1.43 5.12 2 9.46 3.58 14.28.37 1.1 1.41 2.61-.8 2.91-3.33.46-7.83-1.64-9.14-4.92-.81-2-4.12-1.18-5.23-2.51-1.6-1.93-1.52-4.15-3.29-3.6-1.42.43-2.39 1.77-3.69 2.55-2.47 1.49-6.33 6.5-9.3 6.07-11.16-1.61-16.76-1.23-24 1.41-2.21.8-3.87-.64-5.52-.32-2.12.42-3.22-1.24-4.73-2.07-.4 1.08-1.22 2.87-.3 4.1.75 1 2.54.9 4.12.9 1.87 0 4.12 1 6.43 2.71 1.15.85 3.66.5 4.78.32 4-.63 6.09-2.75 10.33-1 4.42 1.81 7.7 4.32 7.58 9.65-.08 3.76.67 7.74.14 11.28-1.47 9.92-3.54 17.35-10.17 25.89-1.33 1.71-1.61 5.22-3 6.94-2.31 2.82-6.66 5.18-9.34 7.73-2.34 2.23-4.31 5.89-6.91 7.75-4.64 3.3-5.49 5.66-9.57 3.71-2.31-1.11-6.34-7.17-7.88-9.32a27.22 27.22 0 01-4.52-10.09 47.84 47.84 0 01-.68-6c-.42-4.3-1.9-5.73-5.22-8.07s-4.31-4.4-6.55-7.77c-3.1-4.66-7.36-4.56-11.57-7.33a7.54 7.54 0 01-3.71-4.93c-.25-1.1.39-5.36.41-6.34.05-2.57-.69-4.61-.62-7.06.22-7.43 11.05-14.23 17-16.9 4.33-1.93 7.12-.65 10.88-.84 1.8-.09 4.72-1 6.36.48 1.13 1 2.7 1.39 4 2.21a25.14 25.14 0 005.71.71c.06 0 .09 0 .14.06a25.48 25.48 0 01-3.35-2.32c-3.22-2.66-5.84-5.86-9.83-7.43s-8.13-1.12-12.38-.87a40.2 40.2 0 01-12.32-1.5c-4.24-1.07-5.84-4.54-6.34-9.85-.18-1.87 1-4.6 1.19-6.7.23-3.32-2.21-5.62.1-9.24s5-8.22 8.79-10.35c3.37-1.88 7.37-2.4 10.85-4a47.09 47.09 0 009.24-6.07c4.57-3.65 8.81-7.73 13.84-10.77 11.42-6.89 25.23-3.38 36.84-9.09 5.78-2.84 12.1-12.42 19.17-12.64a108.87 108.87 0 00-59.23-30.52 22.2 22.2 0 015.2 6.83c2.31 4.92.38 7.38-2.15 11.41s-.14 8.33-3.86 11.41c-2.76 2.29-7.55 3-10.85 4.15-4.27 1.53-8.52 3.11-12.8 4.61s-9.19 3-13.84 2.18c-5.05-.86-6.17-3.21-8.33-7.22-.43-.8-.81-5.41-4.42-5.56-4.83-.2-8.44-.4-11.45 1.6-4 2.68-5.3 8.49-6.24 13.22-1.21 6.06 1.73 13.53-2 18.94-2.19 3.21-6.13 4.43-9.8 4.87-7.23.86-14.19-1.82-21.35-1.86-5.76 0-10 2.69-11.16 7.21-.78 3.14.89 6.45 1 9.68a55.17 55.17 0 01-1.21 13.36c-.36 1.67-1.88 3.67-3.21 2.62a36 36 0 01-8.84-10.13 110.45 110.45 0 00-1.63 12.7 23.47 23.47 0 014.88 3.41c4.17 3.54 3.81 10.3 6.28 15 3.82 7.28 11.26 8.43 17.27 13 3.23 2.47 5.9 5.7 6.27 9.9.19 2.22-.44 3.83-.78 6-1.05 6.4-.12 11.16 2.92 16.91 5.32 10.06 13.73 19.93 24.57 23.93 1.92.71 4.72 1.42 5.73 3s-4.51 3.63-5.83 4.43a26.32 26.32 0 01-11.51 3.86 109.21 109.21 0 00166.11-113.6zm-198.26 27.42a6.1 6.1 0 01-.14-2.82 9.42 9.42 0 00-.75-4.29 3.63 3.63 0 010-3.45c1.1-1.88 2.19.45 3.21 1.74a11.89 11.89 0 011.55 2.7 4.8 4.8 0 01.24.76 7.45 7.45 0 01-.27 2.61 9 9 0 00.14 5c.15.48.65 1.28.21 1.29-1.93.02-3.54-1.89-4.19-3.54zm8.59 12.43c-.24.16-.12-.84-1.16-1.56-1.34-.92-3.68-2-4-3.81-.21-1.18.61-1.79 1.7-2.23.7-.29.73.4 1.14 1.22s1.39 1.08 2.13 1.79c1.12 1.09 1.52 3.76.19 4.59zm29.84-50.26a17.29 17.29 0 00-1.36 4.77c-.16 1.24.12 2.3-.82 3.32-1.28 1.41-3.23 1.11-4.68.11-3.22-2.24-5.34-6.05-8.55-8.43-1.31-1-3.17-1.36-2.69-3.19.53-2 3.44-2.61 5.15-2.59 2.26 0 4.65 1.36 6.5-.08 1.5-1.16 3.68-1.79 4.91-.87 2 1.49 2.38 4.85 1.54 6.96zm114 104.37c-1.09 1.73-1.11 5.61-3.22 7.44s-5.33 1.86-7.4 2.71c-2.86 1.18-3-2.95-2.19-7 .64-3 5.14-4.18 7.19-6.57a26.94 26.94 0 004.61-7.64c.48-1.24.91-3.75 1.89-2.65 3.65 4.01 1.86 9.44-.83 13.71z"
              fill="#691616"
            />
            <path
              d="M272.85 209c-5 3-9.27 7.12-13.84 10.77a47.09 47.09 0 01-9.24 6.07c-3.48 1.64-7.48 2.16-10.85 4-3.83 2.13-6.44 6.68-8.79 10.35s.13 5.92-.1 9.24c-.14 2.1-1.37 4.83-1.19 6.7.5 5.31 2.1 8.78 6.34 9.85a40.2 40.2 0 0012.32 1.5c4.25-.25 8.31-.72 12.38.87s6.61 4.77 9.83 7.43a25.48 25.48 0 003.35 2.32c-.05 0-.08-.06-.14-.06a25.14 25.14 0 01-5.71-.71c-1.29-.82-2.86-1.19-4-2.21-1.64-1.47-4.56-.57-6.36-.48-3.76.19-6.55-1.09-10.88.84-5.95 2.67-16.78 9.47-17 16.9-.07 2.45.67 4.49.62 7.06 0 1-.66 5.24-.41 6.34a7.54 7.54 0 003.71 4.93c4.21 2.77 8.47 2.67 11.57 7.33 2.24 3.37 3.24 5.44 6.55 7.77s4.8 3.77 5.22 8.07a47.84 47.84 0 00.68 6 27.22 27.22 0 004.53 10.12c1.54 2.15 5.57 8.21 7.88 9.32 4.08 1.95 4.93-.41 9.57-3.71 2.6-1.86 4.57-5.52 6.91-7.75 2.68-2.55 7-4.91 9.34-7.73 1.41-1.72 1.69-5.23 3-6.94 6.63-8.54 8.7-16 10.17-25.89.53-3.54-.22-7.52-.14-11.28.12-5.33-3.16-7.84-7.58-9.65-4.24-1.73-6.38.39-10.33 1-1.12.18-3.63.53-4.78-.32-2.31-1.71-4.56-2.71-6.43-2.71-1.58 0-3.37.1-4.12-.9-.92-1.23-.1-3 .3-4.1 1.51.83 2.61 2.49 4.73 2.07 1.65-.32 3.31 1.12 5.52.32 7.25-2.64 12.85-3 24-1.41 3 .43 6.83-4.58 9.3-6.07 1.3-.78 2.27-2.12 3.69-2.55 1.77-.55 1.69 1.67 3.29 3.6 1.11 1.33 4.42.5 5.23 2.51 1.31 3.28 5.81 5.38 9.14 4.92 2.21-.3 1.17-1.81.8-2.91-1.6-4.82-5-9.16-3.58-14.28 1.34-4.92 3.44-5.65 7.19-4.91 3 .6.48 5.35 2 7.73 1 1.51 3.59 2.52 4.52 1.51 2.41-2.61 3.5-6 3.67-10.62.23-5.78 2.46-11.1 3.83-16.62a108.92 108.92 0 00-29.75-55.36c-7.07.22-13.39 9.8-19.17 12.64-11.56 5.73-25.37 2.22-36.79 9.09zM311.82 325.56a26.94 26.94 0 01-4.61 7.64c-2 2.39-6.55 3.55-7.19 6.57-.86 4-.67 8.17 2.19 7 2.07-.85 5.35-.93 7.4-2.71s2.13-5.71 3.22-7.44c2.69-4.27 4.48-9.7.88-13.7-.98-1.11-1.41 1.4-1.89 2.64zM209.84 348c-1-1.6-3.81-2.31-5.73-3-10.84-4-19.25-13.87-24.57-23.93-3-5.75-4-10.51-2.92-16.91.34-2.13 1-3.74.78-6-.37-4.2-3-7.43-6.27-9.9-6-4.6-13.45-5.75-17.27-13-2.47-4.71-2.11-11.47-6.28-15a23.47 23.47 0 00-4.88-3.41c-.17 2.54-.29 5.09-.29 7.67a109.06 109.06 0 0050.09 91.79 26.32 26.32 0 0011.5-3.92c1.33-.8 6.78-2.91 5.84-4.39zM153.17 254.22c1.33 1.05 2.85-.95 3.21-2.62a55.17 55.17 0 001.21-13.36c-.08-3.23-1.75-6.54-1-9.68 1.12-4.52 5.4-7.25 11.16-7.21 7.16 0 14.12 2.72 21.35 1.86 3.67-.44 7.61-1.66 9.8-4.87 3.69-5.41.75-12.88 2-18.94.94-4.73 2.19-10.54 6.24-13.22 3-2 6.62-1.8 11.45-1.6 3.61.15 4 4.76 4.42 5.56 2.16 4 3.28 6.36 8.33 7.22 4.65.79 9.5-.67 13.84-2.18s8.53-3.08 12.8-4.61c3.3-1.19 8.09-1.86 10.85-4.15 3.72-3.08 1.36-7.43 3.86-11.41s4.46-6.49 2.15-11.41a22.2 22.2 0 00-5.2-6.83 109.11 109.11 0 00-125.3 87.32 36 36 0 008.83 10.13zM164.32 272.3a9 9 0 01-.14-5 7.45 7.45 0 00.27-2.61 4.8 4.8 0 00-.24-.76 11.89 11.89 0 00-1.55-2.7c-1-1.29-2.11-3.62-3.21-1.74a3.63 3.63 0 000 3.45 9.42 9.42 0 01.75 4.29 6.1 6.1 0 00.14 2.82c.65 1.65 2.26 3.56 4.18 3.52.48.01-.05-.79-.2-1.27zM166.62 276.12c-.41-.82-.44-1.51-1.14-1.22-1.09.44-1.91 1.05-1.7 2.23.32 1.77 2.66 2.89 4 3.81 1 .72.92 1.72 1.16 1.56 1.33-.83.93-3.51-.19-4.59-.75-.71-1.69-.91-2.13-1.79z"
              fill="#e81a1a"
            />
            <path
              d="M192.33 226.15c-1.85 1.44-4.24.1-6.5.08-1.71 0-4.62.56-5.15 2.59-.48 1.83 1.38 2.22 2.69 3.19 3.21 2.38 5.33 6.19 8.55 8.43 1.45 1 3.4 1.3 4.68-.11.94-1 .66-2.08.82-3.32a17.29 17.29 0 011.36-4.77c.84-2.11.46-5.47-1.54-7-1.24-.88-3.41-.24-4.91.91z"
              fill="#e81a1a"
            />
            <path
              d="M304.24 292.11c-30 52-87.22 74.38-128.87 50.33-30-28.94-46.92-82.09-18.19-132.64 29.67-52.16 93-66.31 140.06-44.65 29.3 28.62 33.25 81.48 7 126.96z"
              fill="#fff"
              opacity={0.2}
            />
            <ellipse
              cx={216.95}
              cy={233.07}
              rx={69.92}
              ry={56.04}
              transform="rotate(-60 216.955 233.062)"
              fill="#fff"
              opacity={0.2}
            />
            <path
              d="M237.05 230.72c-10.79 18.68-31.66 26.81-46.63 18.17s-18.36-30.78-7.57-49.46 31.65-26.81 46.62-18.17 18.36 30.79 7.58 49.46z"
              fill="#fff"
              opacity={0.2}
            />
          </g>
          <g id="servicesbackground__globe2">
            <path
              d="M184.62 90.52c-2.05-.51-4-1.34-6.16-1.42a5.87 5.87 0 01-3.93-1.36c-.37-.35 0-1.31.56-1.67.88-.57 2.64.37 2.86-.75.28-1.39 0-2.17-1.82-2.66s-3.49.73-5.28 1.32c-.41.14-1 .52-1.08-.29a3.44 3.44 0 011.83-3.39c.74-.3.43-1.52.92-1.93.72-.59 1.54-.57 1.34-1.22s-.66-.89-1-1.36c-.55-.92-2.4-2.35-2.24-3.45.59-4.13.45-6.2-.52-8.88-.3-.82.23-1.43.11-2-.15-.79.46-1.2.77-1.76-.4-.14-1.06-.45-1.52-.11s-.33 1-.33 1.53a4.3 4.3 0 01-1 2.38 2.83 2.83 0 00-.11 1.77c.23 1.46 1 2.25.37 3.82s-1.59 2.85-3.57 2.81a38.92 38.92 0 01-4.17 0c-3.67-.55-6.42-1.31-9.58-3.77-.64-.49-1.93-.59-2.57-1.11-1-.86-1.92-2.47-2.86-3.46S143.5 62 142.81 61c-1.22-1.71-2.09-2-1.37-3.54.41-.85 2.65-2.34 3.45-2.92a10.06 10.06 0 013.73-1.67 18 18 0 012.21-.25 3.52 3.52 0 003-1.93 8.66 8.66 0 012.87-2.43c1.73-1.14 1.69-2.72 2.71-4.28a2.83 2.83 0 011.83-1.37 17.81 17.81 0 012.34.15c1 0 1.71-.25 2.62-.23 2.75.08 5.27 4.09 6.25 6.29.72 1.6.24 2.64.31 4 0 .67.37 1.75-.18 2.35a10.53 10.53 0 00-.81 1.48 9 9 0 00-.27 2.11.11.11 0 010 .06 9.18 9.18 0 01.86-1.24c1-1.2 2.17-2.17 2.75-3.64a10.28 10.28 0 00.32-4.58 14.89 14.89 0 01.56-4.56c.39-1.57 1.68-2.17 3.64-2.35a20.3 20.3 0 012.48.44c1.23.09 2.08-.82 3.42 0s3 1.83 3.83 3.25c.7 1.25.89 2.73 1.5 4a17.52 17.52 0 002.24 3.42 49.18 49.18 0 014 5.12c2.55 4.22 1.25 9.33 3.36 13.63 1.06 2.14 4.6 4.48 4.68 7.09a40.35 40.35 0 0011.3-21.91 8.28 8.28 0 01-2.53 1.92c-1.82.86-2.74.14-4.23-.8s-3.08-.05-4.22-1.42c-.84-1-1.09-2.8-1.53-4-.57-1.58-1.15-3.15-1.71-4.74a10.6 10.6 0 01-.81-5.12c.32-1.87 1.19-2.28 2.68-3.08.29-.16 2-.3 2-1.64.08-1.78.15-3.12-.59-4.23-1-1.5-3.14-2-4.89-2.31-2.24-.45-5 .64-7-.73a4.91 4.91 0 01-1.8-3.63c-.32-2.67.67-5.25.69-7.89 0-2.14-1-3.72-2.67-4.14-1.16-.28-2.39.33-3.58.36a20.38 20.38 0 01-4.95-.44c-.62-.14-1.36-.7-1-1.19a13.12 13.12 0 013.75-3.27 42.81 42.81 0 00-4.7-.61 8.33 8.33 0 01-1.26 1.81c-1.31 1.54-3.81 1.41-5.55 2.32-2.7 1.42-3.12 4.17-4.83 6.39a5.26 5.26 0 01-3.66 2.32 7.85 7.85 0 01-2.21-.29 9.09 9.09 0 00-6.26 1.09c-3.72 2-7.37 5.08-8.85 9.09-.26.71-.52 1.75-1.12 2.12s-1.31-1.59-1.61-2.08a9.74 9.74 0 01-1.43-4.3 40.4 40.4 0 0034 62.28 41.31 41.31 0 008.05-.76zm-10.16-73.37a2.2 2.2 0 011-.06 3.47 3.47 0 001.59-.27 1.33 1.33 0 011.27 0c.7.41-.16.81-.64 1.19a4.31 4.31 0 01-1 .57 1.31 1.31 0 01-.28.09 2.68 2.68 0 01-1-.1 3.38 3.38 0 00-1.84.05c-.17.06-.47.25-.48.08a1.89 1.89 0 011.38-1.55zm-4.59 3.17c-.06-.09.31 0 .57-.42s.76-1.37 1.41-1.49c.44-.07.67.23.83.63s-.15.27-.45.42-.4.52-.67.79c-.4.42-1.39.56-1.69.07zm18.59 11.05a6.44 6.44 0 00-1.76-.51c-.46-.06-.85.05-1.23-.3a1.29 1.29 0 010-1.73c.83-1.19 2.24-2 3.12-3.17.36-.48.5-1.17 1.18-1s1 1.27 1 1.9c0 .84-.5 1.73 0 2.41a1.66 1.66 0 01.23 1.83 2.36 2.36 0 01-2.54.57zm-38.62 42.2c-.64-.4-2.07-.41-2.75-1.19s-.69-2-1-2.74c-.44-1.06 1.09-1.13 2.58-.81 1.12.24 1.55 1.91 2.43 2.66a9.84 9.84 0 002.83 1.71c.46.18 1.39.33 1 .7-1.5 1.33-3.51.67-5.09-.33z"
              fill="#691616"
            />
            <path
              d="M197.06 58.78a49.18 49.18 0 00-4-5.12 17.52 17.52 0 01-2.24-3.42c-.61-1.29-.8-2.77-1.5-4-.79-1.42-2.47-2.38-3.83-3.25s-2.19.05-3.42 0a20.3 20.3 0 00-2.48-.44c-2 .18-3.25.78-3.64 2.35a14.89 14.89 0 00-.56 4.56 10.28 10.28 0 01-.32 4.58c-.58 1.47-1.77 2.44-2.75 3.64a9.18 9.18 0 00-.86 1.24.11.11 0 000-.06 9 9 0 01.27-2.11 10.53 10.53 0 01.81-1.48c.55-.6.22-1.68.18-2.35-.07-1.39.41-2.43-.31-4-1-2.2-3.5-6.21-6.25-6.29-.91 0-1.66.25-2.62.23a17.81 17.81 0 00-2.34-.15 2.83 2.83 0 00-1.8 1.29c-1 1.56-1 3.14-2.71 4.28a8.66 8.66 0 00-2.87 2.43 3.52 3.52 0 01-3 1.93 18 18 0 00-2.21.25 10.06 10.06 0 00-3.73 1.67c-.8.58-3 2.07-3.45 2.92-.72 1.51.15 1.83 1.37 3.54.69 1 2 1.7 2.87 2.56s1.82 2.6 2.86 3.46c.64.52 1.93.62 2.57 1.11 3.16 2.46 5.91 3.22 9.58 3.77a38.92 38.92 0 004.17 0c2 0 2.91-1.18 3.57-2.81s-.14-2.36-.37-3.82a2.83 2.83 0 01.11-1.77 4.3 4.3 0 001-2.38c0-.58 0-1.25.33-1.53s1.12 0 1.52.11c-.31.56-.92 1-.77 1.76.12.61-.41 1.22-.11 2 1 2.68 1.11 4.75.52 8.88-.16 1.1 1.69 2.53 2.24 3.45.29.47.79.84 1 1.36s-.62.63-1.34 1.22c-.49.41-.18 1.63-.92 1.93a3.44 3.44 0 00-1.83 3.39c.11.81.67.43 1.08.29 1.79-.59 3.39-1.85 5.28-1.32s2.1 1.27 1.82 2.66c-.22 1.12-2 .18-2.86.75-.56.36-.93 1.32-.56 1.67a5.87 5.87 0 003.93 1.36c2.14.08 4.11.91 6.16 1.42a40.33 40.33 0 0020.48-11c-.08-2.61-3.62-5-4.68-7.09-2.14-4.34-.84-9.45-3.39-13.67zM153.93 73.2a9.84 9.84 0 01-2.83-1.71c-.88-.75-1.31-2.42-2.43-2.66-1.49-.32-3-.25-2.58.81.31.77.34 2 1 2.74s2.11.79 2.75 1.19c1.58 1 3.59 1.66 5.07.33.41-.37-.52-.52-.98-.7zM145.64 35.46c.6-.37.86-1.41 1.12-2.12 1.48-4 5.13-7.12 8.85-9.09a9.09 9.09 0 016.26-1.09 7.85 7.85 0 002.21.29 5.26 5.26 0 003.66-2.32c1.71-2.22 2.13-5 4.83-6.39 1.74-.91 4.24-.78 5.55-2.32a8.33 8.33 0 001.26-1.81c-.94-.06-1.88-.11-2.84-.11a40.38 40.38 0 00-34 18.54A9.74 9.74 0 00144 33.3c.3.49 1.08 2.51 1.64 2.16zM180.33 14.49c-.39.49.35 1 1 1.19a20.38 20.38 0 004.95.44c1.19 0 2.42-.64 3.58-.36 1.67.42 2.68 2 2.67 4.14 0 2.64-1 5.22-.69 7.89a4.91 4.91 0 001.8 3.63c2 1.37 4.77.28 7 .73 1.75.35 3.9.81 4.89 2.31.74 1.11.67 2.45.59 4.23 0 1.34-1.76 1.48-2 1.64-1.49.8-2.36 1.21-2.68 3.08a10.6 10.6 0 00.81 5.12c.56 1.59 1.14 3.16 1.71 4.74.44 1.22.69 3 1.53 4 1.14 1.37 2.75.5 4.22 1.42s2.41 1.66 4.23.8a8.28 8.28 0 002.53-1.92 40.87 40.87 0 00.55-6.68 40.41 40.41 0 00-32.87-39.69 13.12 13.12 0 00-3.82 3.29zM173.64 18.61a3.38 3.38 0 011.84-.05 2.68 2.68 0 001 .1 1.31 1.31 0 00.28-.09 4.31 4.31 0 001-.57c.48-.38 1.34-.78.64-1.19a1.33 1.33 0 00-1.27 0 3.47 3.47 0 01-1.59.27 2.2 2.2 0 00-1 .06 1.89 1.89 0 00-1.3 1.54c-.07.18.23-.01.4-.07zM172.23 19.46c.3-.15.56-.16.45-.42s-.39-.7-.83-.63c-.65.12-1.06 1-1.41 1.49s-.63.33-.57.42c.3.49 1.29.35 1.69-.07.27-.25.34-.62.67-.79z"
              fill="#e81a1a"
            />
            <path
              d="M190.72 29c-.53-.68 0-1.57 0-2.41 0-.63-.21-1.71-1-1.9s-.82.51-1.18 1c-.88 1.19-2.29 2-3.12 3.17a1.29 1.29 0 000 1.73c.38.35.77.24 1.23.3a6.44 6.44 0 011.76.51 2.36 2.36 0 002.59-.6 1.66 1.66 0 00-.28-1.8z"
              fill="#e81a1a"
            />
            <path
              d="M166.31 70.39c-19.23-11.1-27.52-32.27-18.62-47.69a40.24 40.24 0 0149.08-6.7c19.3 11 24.54 34.44 16.52 51.83-10.59 10.82-30.15 12.28-46.98 2.56z"
              fill="#fff"
              opacity={0.2}
            />
            <ellipse
              cx={188.16}
              cy={38.09}
              rx={20.74}
              ry={25.87}
              transform="rotate(-60 188.162 38.095)"
              fill="#fff"
              opacity={0.2}
            />
            <path
              d="M189 45.53c-6.91-4-9.92-11.72-6.73-17.26s11.4-6.79 18.31-2.8 9.92 11.71 6.72 17.25-11.36 6.8-18.3 2.81z"
              fill="#fff"
              opacity={0.2}
            />
          </g>
          <path
            d="M361.36 205.87a149.4 149.4 0 011.64 15.35c17.67 12.66 28.23 28.45 28.44 45.68.52 42.7-62.67 78-141.15 78.93s-142.5-33-143-75.7c-.21-17.57 10.38-33.89 28.37-47.08a129.49 129.49 0 014.38-14.6C107 225.24 86.4 249.18 86.73 275.53c.6 49.54 74.89 88.87 165.94 87.83s164.37-42 163.77-91.58c-.32-26.39-21.55-49.87-55.08-65.91z"
            fill="#1a1a1a"
          />
          <path
            d="M360.68 202.31a138.31 138.31 0 012.12 15.49c17.81 12.68 28.46 28.54 28.67 45.85.52 42.7-62.67 78-141.15 78.93s-142.5-33-143-75.7c-.22-17.9 10.79-34.49 29.39-47.81a126.81 126.81 0 014.92-14.62c-34 16.82-55.21 41.07-54.88 67.82.6 49.55 74.89 88.88 165.94 87.84s164.37-42 163.77-91.58c-.34-26.53-21.86-50.18-55.78-66.22z"
            fill="#4d4d4d"
          />
          <path
            d="M337.26 180c.64 2.25 1.2 4.52 1.71 6.81 58.6 16.27 98.77 49.27 99.24 87.78.67 55.62-81.63 101.64-183.83 102.8s-185.59-43-186.27-98.59c-.47-38.6 39.06-72.56 97.44-90.12.85-2.08 1.7-4.14 2.6-6.19-68.66 18.34-115.92 56.92-115.38 101 .74 60.79 91.91 109.06 203.64 107.78s201.71-51.58 201-112.38c-.57-44.58-49.83-82.41-120.15-98.89z"
            fill="#1a1a1a"
          />
          <path
            d="M336.42 177.25c.7 2.25 1.35 4.53 1.92 6.84 58.94 16.2 99.4 49.3 99.87 88 .67 55.61-81.63 101.64-183.83 102.8s-185.59-43-186.27-98.59c-.47-38.86 39.59-73 98.63-90.47.88-2.08 1.79-4.13 2.72-6.19C100.1 197.79 52.23 236.57 52.77 281c.74 60.8 91.91 109.06 203.64 107.79s201.71-51.59 201-112.39c-.57-44.81-50.23-82.76-120.99-99.15z"
            fill="#4d4d4d"
          />
          <path
            fill="#691616"
            d="M362.09 19.24v15.37l23.53-13.59V5.66l-23.53 13.58z"
          />
          <path
            d="M382.28 46c0 6.21-3.77 13.41-8.43 16.1s-8.42-.17-8.42-6.37 3.77-13.41 8.42-16.09 8.43.2 8.43 6.36z"
            fill="red"
            opacity={0.5}
          />
          <path
            d="M328.92 89.41l41.71-36.89v-.12a8.83 8.83 0 013-6.45V28l1.41-.82v18.05c1.54-.36 2.69.83 2.69 3.05 0 2.63-1.6 5.68-3.57 6.82-1.46.84-2.71.39-3.26-1L329 91.22z"
            fill="#c1272d"
            opacity={0.5}
          />
          <path
            d="M375 110.81c-.39-.14-5.54-4-6.46-4.83s-1.19-.12-.8.87 1.06 2.37 1.06 2.37a9.63 9.63 0 00-4.68-1.65c-2.51-.07-3.57 1.06-1.39 3.24 1.61 1.61 10 4.68 10 4.68zM403.43 124.53c0 4.77-5.49 8.18-9.24 4.15a12.09 12.09 0 01-2.52-4.34 125.31 125.31 0 014.76-17l5.53.9a155.19 155.19 0 011.47 16.29z"
            fill="#ffe1db"
          />
          <path
            d="M398.14 118.65l6.48-2.37s-1.83-8.23-3.2-11.47c-1-2.46-2-5-5.18-5.65a3.84 3.84 0 00-4.54 3.22c-.57 3.24 6.44 16.27 6.44 16.27z"
            fill="#fff"
          />
          <path
            d="M396.55 228.1c-.92 2.19-3 2-7.3.45a37 37 0 01-9.61-4.9c-2.69-2-2.72-2.26-3.08-3.61-.49-1.89 2.26-2.94 6.84-1.52l1.26.4a2.78 2.78 0 00-2.09 1.16c-.83 1.57 1.77 3.24 4.51 4.61s5 1.37 6.35.75c1-.46 2.35-1 3-1.33.28 1.83.67 2.68.12 3.99z"
            fill="#471313"
          />
          <path
            d="M391.26 202.85c0 .38-.12-3.37-.22-8.12a39.79 39.79 0 01-10 2.84c.29 2.11.61 4.21.91 6.21.78 9.09 1.46 20.88 1.46 20.88s-1.27-.56-3.79-1.4a2.8 2.8 0 00-2.1 1.16c-.83 1.57 1.78 3.24 4.52 4.61s5 1.37 6.35.75c1-.46 2.35-1 3-1.33a22.48 22.48 0 01-.11-5.38c.38-4.88.23-14.07-.02-20.22z"
            fill="#ffe1db"
          />
          <path
            d="M396.83 198.27c.08-1.14.21-2.4.34-3.7a25.84 25.84 0 01-9.95 1.16c.18 3.64.36 7 .49 9 .44 6.8.74 15.59.74 15.59s-1.26-.57-3.79-1.4a2.78 2.78 0 00-2.09 1.16c-.83 1.57 1.77 3.24 4.51 4.61s5 1.37 6.35.75c1-.46 2.35-1 3-1.33a22.08 22.08 0 01-.1-5.38c.35-4.05.19-16.56.5-20.46z"
            fill="#ffe1db"
          />
          <path
            d="M391.46 232.45c-.91 2.18-3 2-7.3.44a37.07 37.07 0 01-9.6-4.9c-2.7-2-2.72-2.26-3.08-3.61-.5-1.88 2.26-2.94 6.84-1.52l1.26.4a2.8 2.8 0 00-2.1 1.16c-.83 1.57 1.77 3.24 4.52 4.61s5 1.37 6.35.75c1-.46 2.35-1 3-1.33.28 1.84.65 2.69.11 4z"
            fill="#471313"
          />
          <path
            d="M383.69 181.82c-3.3 3.87-6.23 5.7-11.35 6.32 0 7.18 10.21 33.68 10.23 34.88 1.85 2.23 4.4 3 9.52 1.59.19-3.7-4.32-25.21-8.4-42.79z"
            fill="#691616"
          />
          <path
            d="M398.14 143c-3.06-7.24-2.81-8-2.69-8l-20.28 2.5s-.54 5-1.4 9.11c-1.28 6.11-1.45 34.29-1.43 42.91 1.73-.22 2.07.37 3.76-.14 3.16-.93 5 4.52 7.6 2.6 0 0 1.37-4.09 1.37-4.12.55-10.77 1.08-16.66 3.21-22.81.21 3.24-1.34 18.79-1.15 25.43.17 6.07-.73 21.12-.73 27.86 2.67 3.24 8.12 3.24 10.86 1.62.78-4.34 1.45-28.17 1.94-35.13.1-2.61 1.08-19.91 1.46-23a34.43 34.43 0 00-2.52-18.83z"
            fill="#691616"
          />
          <g id="servicesbackground__globe3">
            <path
              d="M318 102.55c2.08-.07 3.3-.81 5.82.72 1.83 1.1 3.87 3.81 6 3.76s4.65-2.92 6.18-3.68c3.59-1.8 6.11-8.36 9.06-11.2 1.87-1.8 3.06-.29 4-1 .68-.49 1.12-2.06 1.65-3.86 1.13-3.76-.53-5.27-2.37-4.75-4.24 1.21-3.69 3.34-5.42 3.85-2.9.87-4.58 1.85-5.6.63-2.42-2.89-4.07-4.52-7.34-5.36-2.72-.69-2.29-1.11-5.71-.38-1.36.29-3.3 1.21-4.63 1.59-3.21.93-5.33 1.1-6.08-1.78-.51-2-3.48-2.78-3.67-4.52s.54-1.65.57-4.31c0-4.15-1.34-4.89-2.91-6.22a4 4 0 01-.72-.81 31.4 31.4 0 006.53 37.28c1.49.14 3.81.07 4.64.04z"
              fill="#fff"
            />
            <path
              d="M318 102.55c2.08-.07 3.3-.81 5.82.72 1.83 1.1 3.87 3.81 6 3.76s4.65-2.92 6.18-3.68c3.59-1.8 6.11-8.36 9.06-11.2 1.87-1.8 3.06-.29 4-1 .68-.49 1.12-2.06 1.65-3.86 1.13-3.76-.53-5.27-2.37-4.75-4.24 1.21-3.69 3.34-5.42 3.85-2.9.87-4.58 1.85-5.6.63-2.42-2.89-4.07-4.52-7.34-5.36-2.72-.69-2.29-1.11-5.71-.38-1.36.29-3.3 1.21-4.63 1.59-3.21.93-5.33 1.1-6.08-1.78-.51-2-3.48-2.78-3.67-4.52s.54-1.65.57-4.31c0-4.15-1.34-4.89-2.91-6.22a4 4 0 01-.72-.81 31.4 31.4 0 006.53 37.28c1.49.14 3.81.07 4.64.04z"
              fill="red"
            />
            <path
              d="M366.93 79.5a31.7 31.7 0 00-60-14.25 4 4 0 00.72.81c1.57 1.33 2.95 2.07 2.91 6.22 0 2.66-.77 2.52-.57 4.31s3.16 2.54 3.67 4.52c.75 2.88 2.87 2.71 6.08 1.78 1.33-.38 3.27-1.3 4.63-1.59 3.42-.73 3-.31 5.71.38 3.27.84 4.92 2.47 7.34 5.36 1 1.22 2.7.24 5.6-.63 1.73-.51 1.18-2.64 5.42-3.85 1.84-.52 3.5 1 2.37 4.75-.53 1.8-1 3.37-1.65 3.86-1 .69-2.16-.82-4 1-3 2.84-5.47 9.4-9.06 11.2-1.53.76-3.9 3.63-6.18 3.68s-4.18-2.66-6-3.76c-2.52-1.53-3.74-.79-5.82-.72-.86 0-3.18.1-4.6 0a31.6 31.6 0 0039 3.62l-.23-.18a12.15 12.15 0 01-2.06-4.19c-.24-1.15.66-2.44.5-3.62-.12-1-.92-.84-1.72-.92-.42 0-.56-.79-.66-1.33a2.54 2.54 0 011.07-2.61c1.72-1.31 3.2-1 5.07-.46a6.56 6.56 0 012.55 1.39c.79.7.74 3 1.81 2.46s1.64-1.4 2.27-1.43a6.89 6.89 0 011.65.07 31.77 31.77 0 004.29-15.83z"
              fill="#c1272d"
            />
            <path
              d="M361 95.26c-.63 0-1.18.89-2.27 1.43s-1-1.76-1.81-2.46a6.56 6.56 0 00-2.55-1.39c-1.87-.56-3.35-.85-5.07.46a2.54 2.54 0 00-1.07 2.61c.1.54.24 1.29.66 1.33.8.08 1.6 0 1.72.92.16 1.18-.74 2.47-.5 3.62a12.15 12.15 0 002.06 4.19l.23.18a31.88 31.88 0 0010.25-10.82 6.89 6.89 0 00-1.65-.07z"
              fill="#fff"
            />
            <path
              d="M361 95.26c-.63 0-1.18.89-2.27 1.43s-1-1.76-1.81-2.46a6.56 6.56 0 00-2.55-1.39c-1.87-.56-3.35-.85-5.07.46a2.54 2.54 0 00-1.07 2.61c.1.54.24 1.29.66 1.33.8.08 1.6 0 1.72.92.16 1.18-.74 2.47-.5 3.62a12.15 12.15 0 002.06 4.19l.23.18a31.88 31.88 0 0010.25-10.82 6.89 6.89 0 00-1.65-.07z"
              fill="#ed1c24"
            />
            <path
              d="M351.71 67c.55-.95.09-2.47.44-3.23.58-1.28 1.56-3.86.2-5.6-1.54-2-4.27-2.06-6.92-.95-3.08 1.29-1 4.52-2.14 6.85-.55 1.11-3 1-4.47 1.08-1.87.09-2.2 1.08-3.18 2.9s-3.73 3-2.66 5c.4.79 2.2 2.08 3.31 1.82 1.75-.4 3.42-.81 4.19 1.21.61 1.6 2 3.79 4.55 3.31 2.33-.44 3.58-2.2 5.18-3.87 1.13-1.17 2.79-2.09 2.7-3.38-.12-1.58-2.1-3.57-1.2-5.14z"
              fill="red"
            />
            <g>
              <path
                d="M350.4 87.51c-8.72 15.1-25.34 21.61-37.45 14.62a31.58 31.58 0 01-5.28-38.54c8.62-15.16 27-19.27 40.69-13 8.52 8.34 9.64 23.7 2.04 36.92z"
                fill="#c1272d"
                opacity={0.1}
              />
              <ellipse
                cx={325.03}
                cy={70.35}
                rx={20.32}
                ry={16.28}
                transform="rotate(-60 325.03 70.35)"
                fill="#fff"
                opacity={0.1}
              />
              <path
                d="M330.87 69.67c-3.13 5.43-9.2 7.79-13.54 5.28s-5.34-9-2.21-14.37 9.2-7.79 13.55-5.28 5.33 8.94 2.2 14.37z"
                fill="#fff"
                opacity={0.1}
              />
            </g>
          </g>
          <path
            d="M382.83 75c-1.06.74-5.4.61-6.5 9.32-1 7.72 1.26 8.43 2.83 9.08.86.36 4 1.4 4 1.4l-.35 7.8a11.06 11.06 0 007.48 0l3.67-1.51a12.85 12.85 0 01-1.2-6.74c.3-5.3 2.18-12.85.85-15.65-2.38-5.09-7.91-5.7-10.78-3.7z"
            fill="#ffe1db"
          />
          <path
            d="M401.31 147.64c-1.16 1.49-2.79 1.69-5.25 2.48a12.35 12.35 0 00-2-4.3s-.72 3.39-1.1 5.46c-2.12.51-6.09 1.12-7 1.23-4.12.49-11.68-2-13.61-5.07 2.51-7.84 3.67-23 3.67-23s-3.68-10-1.05-15.28 6-5.9 8.5-6.75S394.7 100 394.7 100s8.11 6.33 6.32 14.23a75.7 75.7 0 00-1.82 14.48c-.2 3.01 2.05 15.99 2.11 18.93z"
            fill="#c1272d"
          />
          <path
            d="M372.37 135.25c-2.23 1.32-2.72 1.56-5.76-.14-1.77-2.31 1.43-4.05.49-6.88 2.09-5.91 5-12.25 5-12.25l9 2.83s-2.24 5.51-5 11c-1.1 2.35-2.93 4.97-3.73 5.44z"
            fill="#ffe1db"
          />
          <path
            d="M344.45 115.94c3.09 1.17 4.79 1.69 4.79 1.69a4.58 4.58 0 00-.49-2.41c-.62-1.1.42-2.43 1.57-.49s3 3 4 4.82 2.66 2.32 8 4.58c3 1.25 5.63 2.23 7.72 3.14a26.58 26.58 0 00-2.43 8.38c-5.88-3-13.61-9.94-15.65-10.82-2.42-1-7.53-3.51-10.16-6.38-1.55-1.69-.11-3.54 2.65-2.51z"
            fill="#ffe1db"
          />
          <path
            d="M377.94 105.13c1.58-.38 4.62 1 5.65 4.5 1.58 5.42-.5 8-1.72 10.7-.4.88-2.11 4-2.11 4a10.06 10.06 0 01-6.5-1.46 6.72 6.72 0 01-3.22-3.64s1-3.82 2.07-7.25c.95-3.04 2.68-6.08 5.83-6.85z"
            fill="#fff"
          />
          <path
            d="M380.48 103.49a4.67 4.67 0 013.68-2.75c7.75-.74 9-1.83 9-1.83a2.46 2.46 0 012.5 1.09l.94 1.59s-9.07 4.52-16.12 1.9z"
            fill="#ffa08d"
          />
          <path
            d="M375.61 81.13a25.2 25.2 0 004.69 2.52c-.81 13.91-3.62 16.8 2 20.16 1.66 1 5.15 2.26 5.78 8 1 8.85 6.51 10.59 6.51 10.59s5.77-5.53 5.88-18.85c.06-7-.47-25.12-3.15-28.39-4.33-5.26-9-5.36-13.48-3.48-3.54-.82-7.33.75-8.23 9.45z"
            fill="#471313"
          />
          <g>
            <path
              d="M108.53 308.22c-2.13 5.31-5 19.12-4.84 20.79.34 3.57 6.37 7.18 7.4 4.4 1.23-3.36 3.49-11 4.24-12.93a162.77 162.77 0 004.82-16.12c.33-5.92 3.3-15.93 7.18-20 0 0-3.33-1.73-5.82.55a36.39 36.39 0 00-6.57 8.48c-.83 1.66-4.75 10.67-6.41 14.83z"
              fill="#471313"
            />
            <path
              d="M77.78 399c-2.57 2.5-3.36 3.22-5.74 5.55-1.39 1.35-.25 2.6 2.4 2.5A47.6 47.6 0 0085 404.79a54.05 54.05 0 007.9-4.12 5.24 5.24 0 002.35-3v-4.17l-12.62.53s-2.08 2.29-4.85 4.97zM100 412.2c-2.57 2.5-3.36 3.22-5.74 5.55-1.39 1.35-.25 2.6 2.4 2.5a47.1 47.1 0 0010.55-2.25 53.52 53.52 0 007.9-4.11 5.3 5.3 0 002.35-3v-7.36l-12.63 3.72s-2.07 2.25-4.83 4.95z"
              fill="#592929"
            />
            <path
              d="M145.06 339.44l-25.22-9.7a71.09 71.09 0 01-11.73 8.56c-4.43 2.68-16.65 9.86-20.57 12.63-2.41 1.7-3.49 5.38-4.43 13.65-1.55 13.68-2.69 29.29-2.69 29.29s2.73 3.81 8.91 3.79a24.13 24.13 0 008.3-1.49l1-31.46 20.64-11.93s-11.71 7.25-13.39 13.68a63.15 63.15 0 00-2 15.58c-.45 13.9-.59 23-.59 23s.91 4.6 7.1 4.58c4.74 0 8.65-3.88 8.65-3.88l1.25-31.85s17.83-12.71 22.51-18.08c5.2-6.02 2.26-16.37 2.26-16.37z"
              fill="#471313"
            />
            <path
              d="M124.22 285.75s-7.54 6.09-8.44 14.7c-.44 4.27.71 18.92.75 28.36-3.63 2.46-14 8.53-14 8.53s8.35 2.57 11.61 8.31a28.06 28.06 0 006-3.55s-.34 1-2.23 4.76c2.27.69 10-1.12 17.26 2s12.22 1.73 12.22 1.73a39.54 39.54 0 00.37-11.95c-.79-5.21-2.74-11-2.34-14 1.25-9.56 3.11-25 2.77-27.55-.56-4.23-10.16-8.82-10.16-8.82s-6.75-5.27-13.81-2.52z"
              fill="#592929"
            />
            <path
              d="M128.6 284.94s-4.41 0-8.14 7.25c-1.33 2.6-2.22 4-2.22 4l2.22 2.16-3.15 1.52s-1.14 11.05-.23 15.62c1 5.05 6.14 14.25 6.14 14.25s3.33-10.32 4.79-12.89 7-9.68 7-9.68l-2.79-4.17 4.51-1.48s6.35-8 5.69-10.36a7.79 7.79 0 00-5.55-5.41z"
              fill="#471313"
            />
            <path
              d="M123.41 293.15a103.54 103.54 0 00-2.77 10.34c-1 4.9 1.75 20.93 1.75 20.93s2.42-15.66 5.62-20.2a104.28 104.28 0 018.72-10.49s-10.06-1.83-13.32-.58z"
              fill="#fff"
            />
            <path
              d="M125.28 294.16l-.53 4.19a11.41 11.41 0 00-3 5.32c-.53 2.93-.38 13.88-.38 13.88l1 6.87 1.47-4.73s1.13-6.51 2.1-10.53a24.75 24.75 0 01.44-3.65 29 29 0 00.81-6l2.62-3.13-2.5-2.92z"
              fill="url(#servicesbackground__linear-gradient)"
            />
            <path
              d="M126.92 285.48l-.46 6.63a17.72 17.72 0 003.11 3.21c2.4-.75 8-5.91 8-5.91l-1.85-10.29z"
              fill="#ffd0c7"
            />
            <path
              d="M136.7 267.8c-2.49-3.17-9.66-5.85-14.33 1.06-4.9 7.25-.27 19.1 4 18.4 2.4-.38 7.81-2.57 10.18-6.44 2.69-4.36 2.09-10.55.15-13.02z"
              fill="#ffe1db"
            />
            <path
              d="M126.79 287.29l.54 6.13-4.33 1.79s-.48-6.5 3.79-7.92z"
              fill="#fff"
            />
            <path
              d="M136.87 285.75a32.74 32.74 0 01-4.06 4.73 15.29 15.29 0 01-5.48 2.94l1.65 4.93s6-2.76 8.24-5.17c0 0 2.62-4.52-.35-7.43z"
              fill="#fff"
            />
            <path
              d="M120.53 271.28c1 1.59 2.55 3.45 6.54 3.66a16 16 0 005.85-.8l-.28 4.36a3.7 3.7 0 001.2-.16c.43-1.66 1.14-2 1.95-1.35s.78 3.83.78 3.83a11.2 11.2 0 003.45-8c0-3.11-2.74-9.85-8.44-10.56s-9.77 2.27-11.16 5.32a4 4 0 00.11 3.7z"
              fill="#471313"
            />
            <g>
              <path
                d="M133.38 346.8h-1l-22.76-13.14a5.32 5.32 0 00-4.73.2l-15.32 8.85a3.3 3.3 0 00-.4.32h-.75v1.29a1.39 1.39 0 00.76 1.12l22.94 13.24a5.28 5.28 0 004.73-.19l15.32-8.85a1.85 1.85 0 001.11-1.57z"
                fill="#ef0e0e"
              />
              <path
                d="M112.18 357.48l-22.94-13.25c-1.21-.7-1-1.92.34-2.73l15.32-8.85a5.28 5.28 0 014.73-.19l22.94 13.24c1.21.7 1.05 1.93-.34 2.73l-15.32 8.85a5.32 5.32 0 01-4.73.2z"
                fill="#fee9e9"
              />
              <path
                fill="#f89a9a"
                d="M107.73 332.89l-16.17 9.33 24.1 13.84 16.22-9.3-24.15-13.87z"
              />
              <path
                fill="#fee9e9"
                d="M106.35 332.74l-1.24.71 24.1 13.85 1.28-.69-24.14-13.87zM124.74 345.68l-1.24.72 3.65 2.08 1.28-.69-3.69-2.11zM120.74 343.36l-1.24.72 2.56 1.48 1.28-.69-2.6-1.51zM117.55 341.55l-1.24.72 2.56 1.48 1.28-.69-2.6-1.51zM114.37 339.73l-1.24.72 2.56 1.48 1.29-.69-2.61-1.51zM122.02 349.13l-1.24.72 1.8 1.04 1.29-.69-1.85-1.07zM119.39 347.6l-1.24.72 1.8 1.04 1.29-.69-1.85-1.07zM116.15 345.77l-1.23.72 2.56 1.48 1.28-.69-2.61-1.51zM119.9 350.36l-1.24.71 1.81 1.04 1.28-.69-1.85-1.06zM117.27 348.83l-1.23.71 1.8 1.04 1.28-.69-1.85-1.06zM117.65 351.54l-1.24.72 1.8 1.04 1.29-.69-1.85-1.07zM115.02 350.01l-1.24.72 1.81 1.04 1.28-.69-1.85-1.07zM114.03 347l-1.23.71 2.56 1.48 1.28-.69-2.61-1.5zM113.07 343.96l-1.24.72 2.57 1.47 1.28-.69-2.61-1.5zM109.9 342.14l-1.24.72 2.56 1.47 1.28-.69-2.6-1.5zM121.89 346.51l-1.23.72 4.26 2.44 1.28-.69-4.31-2.47zM118.51 344.55l-1.24.72 2.56 1.48 1.29-.69-2.61-1.51zM115.32 342.74l-1.24.71 2.56 1.48 1.28-.69-2.6-1.5zM112.14 340.92l-1.23.71 2.56 1.48 1.28-.69-2.61-1.5z"
              />
              <path
                d="M122.29 336.13s-3.77 1.95-6.14 3.13-9.42 7.26-7.92 8.66 5.2 3 6.2 2.81 3.41-2.72 3.79-3.3 5-2.32 6.29-4.32-2.22-6.98-2.22-6.98z"
                fill="#ffe1db"
              />
              <g>
                <path
                  d="M116.16 355l-.07-19.49a1.91 1.91 0 00-1-1.64l-23-13.16a1.9 1.9 0 00-2 .07l-.84.49h.37a1.8 1.8 0 00-.37 1.08l.07 19.5a1.9 1.9 0 001 1.63l23 13.16a1.63 1.63 0 00.48.13l.43.44 1.23-.82a1.83 1.83 0 00.7-1.39z"
                  fill="#f56a6a"
                />
                <path
                  d="M115.14 336.09l.07 19.49a1.89 1.89 0 01-2.83 1.65l-23-13.16a1.89 1.89 0 01-.95-1.63l-.07-19.5a1.89 1.89 0 012.83-1.65l23 13.16a1.92 1.92 0 01.95 1.64z"
                  fill="#f89a9a"
                />
              </g>
              <path
                fill="#fff"
                d="M95.74 349.19l-5.43-3.14v-2.37l5.43 3.13v2.38zM110.54 357.74l-5.43-3.13v-2.38l5.43 3.14v2.37zM103 339.87c0 1.14-1 1.47-2.26.75a4.52 4.52 0 01-2.26-3.36c0-1.13 1-1.47 2.26-.75a4.52 4.52 0 012.26 3.36z"
              />
            </g>
            <path
              d="M152.63 317.9c1.45-10.22 1.38-19-4.18-22.69-4-2.66-6.42 8.16-7.52 16.24-.26 1.94-2.09 10.86-2.54 13-2.7.65-17.37 10.18-19.2 11.93.46.92 3.88 3.46 4.87 9 6.09-1.34 15.71-7.26 22.1-10.55 4.73-2.46 5.84-12.14 6.47-16.93z"
              fill="#471313"
            />
          </g>
          <g>
            <path
              d="M430 340.51a55.28 55.28 0 00-11.8 4.87c-5.06 3-7.48 6.3-10.91 4.45S402.06 336 402.06 336l29.73-5.36s1.89 7.59-1.79 9.87z"
              fill="#400a0a"
            />
            <path
              d="M428.55 327.24s7.37 6.17 6.84 12.69c-.29 3.56.14 5.14-.42 9.56-.53 4.17-.1 19.34.14 24.82.12 2.74 4.68 6.08 6.77 7.6s1.19 3.59 1.87 4.55c1.35 1.92-4.43 3.44-7.59.7s-8.36-4.81-8.58-9.34a116.73 116.73 0 00-2.68-20.68c-1.08-4.45-1-9.88-.9-14 0-2.74-10-11.47-10.41-12.34-.95-2.19 14.96-3.56 14.96-3.56z"
              fill="#ffe1db"
            />
            <path
              d="M418.57 337.78a10.56 10.56 0 012.82 9.05 48.65 48.65 0 00-1.24 9.88c0 4.2-1.93 22.17-1.69 27.66.17 4 1.44 8 1.65 10.36.11 1.27-.74 3.06-.66 4.39.15 2.34-5.54 1.92-7.29 1.1s-1.56-12.57-.24-15.83c-.05-4.21-1.15-11.27-2.94-18.67s.51-17.36-1-19.2c-3.09-3.7-9.56-6.92-9.78-10.67-.27-4.67 4.38-12.36 9-10.27 1.52.7 5.61 6.42 11.37 12.2z"
              fill="#ffe1db"
            />
            <path
              d="M384.74 315.33s-4.24 11.45-.31 18.54c3.24 5.84 22.85 16 22.85 16s1.44-7.5 6.27-10.52c4.07-2.55 18.89-8.38 18.89-8.38s-1.22-2.53-5.29-5.7c-4.71-3.68-19.63-13.2-19.63-13.2s-9.07 11.15-22.78 3.26z"
              fill="#471313"
            />
            <path
              d="M419.91 306.54c1.64-.8 3.34-1.51 5.06-2.15a71.49 71.49 0 00-3.12-7.16 79.32 79.32 0 00-4.39-7.58c-1.46-1.94-5.79-8.12-5.79-8.12l-6.39 4.78s7.83 9.25 8.85 10.62a94.71 94.71 0 015.74 9.21 1.32 1.32 0 01.04.4z"
              fill="#ffe1db"
            />
            <path
              d="M441.88 381.91a20 20 0 015.43 4.1c1.78 2.23-.24 5.57-5.05 4.84-2.55-.38-5.95-3.11-7.32-4.12-1.91-1.43-5.27-3-6.78-4.34s-.58-4.57-.58-4.57a7.09 7.09 0 002.37 3.29 30 30 0 005.89 3.48c3 1 5.08 1.78 6.24.37s-.2-3.05-.2-3.05zM419.92 393.37s.35 3.2-.84 4.86-4.18 1.8-5.91-1.18c-1.61-2.79-1.79-6.68-1.91-8.54a12.72 12.72 0 01.66-4.12 3.31 3.31 0 00-1.48 3.65c.57 2.54-.15 6.28 0 8.19.3 4.55 1.48 7.91 4.75 9.38 2.63 1.18 6.49.31 6.43-4.1a22.6 22.6 0 00-1.7-8.14z"
              fill="#592929"
            />
            <path
              d="M406.34 287.62a10.84 10.84 0 002.65-1.83 13.6 13.6 0 002.71-3.59s-2.33-8.66-9-11.25c-3.26-1.28-7.51 2.31-7.51 2.31z"
              fill="#fff"
            />
            <path
              d="M411.2 280.72l1 1.79s-2.2 4.29-5.09 5.11-1.4-1.83-1.4-1.83 1.73.75 5.49-5.07z"
              fill="#fff"
            />
            <path
              d="M378.07 285.74c.55-2.71 8.47-8.73 8.47-8.73s4.76 3.43 6.44 4.62a40.16 40.16 0 014.56 4.37 35.31 35.31 0 00-2.38-8.88c-.57-1.35 0-5.41 0-5.41s.63-.19 1.55-.4c1.47 1.48 4.41 5.44 6 7.07s7.33 6.41 6 11.78a43.38 43.38 0 01-1.64 5c-.83 2.23-.56 6.39-.34 8.64.27 2.59 3 9.32 3 9.32s-5.63 7.19-12 7.22c-7.48 0-13-5-13-5s1.24-11.37.77-16c.01-.02-9.22-4.64-7.43-13.6z"
              fill="#fff"
            />
            <path
              d="M397.73 275.83s4.68 5.33 4.31 7.45c-1.17 1.13-3.91 3.36-3.91 3.36L395 276.22z"
              fill="#fff"
            />
            <path
              d="M407.28 318.27a90.56 90.56 0 00-14-8.88 14.77 14.77 0 01-3.28-5.79c-1-2.83-2.68-6.89-2.68-6.89l-8.46 2.82s3.29 7.62 4.81 10.11c1 1.61 2.61 4.67 4.88 6.36s5.4 3.9 16.12 7.11c.39-1.95 2.64-4.81 2.61-4.84z"
              fill="#ffe1db"
            />
            <path
              d="M403.58 273.88a12.6 12.6 0 011.79 1.92c.93-12-.79-17.24-.79-17.24l-6.94 12s-.2.17-.46.42a12.52 12.52 0 016.4 2.9z"
              fill="url(#servicesbackground__linear-gradient-2)"
            />
            <path
              d="M395.71 272.3a28.38 28.38 0 001.1 7c.73 1 1.58 4.36 1.32 7.31-1.55-.79-4.17-3.28-5.65-4.56-1.8-1.56-6.5-4.59-6.5-4.59l.16-13.67z"
              fill="#ffc0b4"
            />
            <path
              d="M390.21 256.07c3-2.3 10.17-3 12.78 4.36 2.74 7.75-4.27 17.44-8 15.79-2.1-.92-6.5-4.19-7.74-8.28-1.4-4.59.61-10.08 2.96-11.87z"
              fill="#ffe1db"
            />
            <path
              d="M386 274.68a31.18 31.18 0 015.52 4.47c4 4.18 6.6 7.48 6.6 7.48s-1.28.91-6.05 1.32c-3.86-3.73-7.18-6-8.53-8.5.08-1.14 2.46-4.77 2.46-4.77zM380.23 302.55c-1.65-2.07-3.59-4.12-4-5.39-1-3.36-2.78-8.72 2.54-12.86 4.19-3.25 8.24 4.66 9.08 7.6a24.81 24.81 0 01.7 7.82c-1.21 1.62-5.39 4.03-8.32 2.83z"
              fill="#fff"
            />
            <path
              d="M388.74 298.88a16.24 16.24 0 00.37 2.23 10.58 10.58 0 01-4.68 2.52 14.85 14.85 0 01-3.45.56l-1.23-2.19a18 18 0 004.68-.78 22.84 22.84 0 004.31-2.34z"
              fill="#fff"
            />
            <path
              d="M403.65 256.26c-5-8.69-11.13-4.15-11.13-4.15s-3.41-2.06-7.06 2.6c-2 2.53-4.33 12.11-2 17.29.78 1.73 3.51 5.64 9.61 6.5-1-2.1-.46-7.28 1-9.45 2.61-4 2.27-9.6 2.27-9.6a9.59 9.59 0 017.33 5.34 7.9 7.9 0 00-.02-8.53z"
              fill="#471313"
            />
            <path
              d="M431.32 296.2c-.21-.13-.57-.12-1.09.11l-11 6.35a8.94 8.94 0 00-3.51 3.19l-11.84 20.5c-.4.7-.43 1.18-.15 1.37l1.17.67.54-1.15 10.35-6a8.83 8.83 0 003.52-3.19l11.83-20.5.08-.15.26.27.93-.85-1.11-.65z"
              fill="#ef0e0e"
            />
            <path
              d="M431.37 297l-11 6.35a8.88 8.88 0 00-3.51 3.19L405.05 327c-.71 1.23-.28 1.8.94 1.27l11-6.35a8.9 8.9 0 003.52-3.19l11.83-20.5c.66-1.23.25-1.8-.97-1.23z"
              fill="#f89a9a"
            />
            <path
              d="M426.84 307.71c-2.81 1.76-5.1 5.08-4.69 6.94s2.7.18 3.76-1.5a6 6 0 00.93-5.44zM404.35 316.14s2.12 1 3.19.19a5.74 5.74 0 012.9-1.28s-.95 1.45.38 2 1.5.68 3.42.16c1.42-.38 2.6-.19 1.36 2.35a10.31 10.31 0 01-5.11 4.3c-2.17.57-4.46-.25-6.91-1-4.06-1.34.77-6.72.77-6.72z"
              fill="#ffe1db"
            />
          </g>
          <g id="servicesbackground__news1">
            <path
              fill="#f01f1f"
              opacity={0.5}
              d="M494.53 161.07L435 195.44v72.68l59.53-34.37v-72.68z"
            />
            <path
              fill="#691616"
              d="M470.04 243.68l-30.41 17.56v-33.09l30.41-17.56v33.09z"
            />
            <path
              fill="#fff"
              opacity={0.5}
              d="M473.99 177.13v25.26l16.55-9.56v-25.26l-16.55 9.56z"
            />
            <path
              fill="#643838"
              opacity={0.6}
              d="M473.99 210.13v30.56l16.55-9.55v-30.57l-16.55 9.56zM470.04 183.88l-30.41 17.56v-3.35l30.41-17.56v3.35zM470.04 190.81l-30.41 17.56v-3.35l30.41-17.56v3.35zM470.04 197.98l-30.41 17.56v-3.35l30.41-17.56v3.35zM470.04 204.91l-30.41 17.56v-3.35l30.41-17.56v3.35z"
            />
          </g>
          <g>
            <path
              d="M118.22 177.26c0 10.74 6.53 23.23 14.59 27.88s14.59-.29 14.59-11-6.53-23.23-14.59-27.89-14.59.26-14.59 11.01z"
              fill="red"
              opacity={0.5}
            />
            <path
              d="M125.43 182.11c0 4.55 2.77 9.84 6.19 11.82s6.18-.13 6.18-4.68-2.77-9.84-6.18-11.81-6.19.12-6.19 4.67z"
              fill="#fff"
              opacity={0.6}
            />
          </g>
          <g>
            <path
              d="M323.2 27c0 7.3-4.43 15.78-9.91 18.94s-9.91-.2-9.91-7.49 4.44-15.78 9.91-18.94 9.91.16 9.91 7.49z"
              fill="red"
              opacity={0.5}
            />
            <path
              d="M318.3 30.26c0 3.09-1.88 6.69-4.2 8s-4.19-.08-4.19-3.17 1.88-6.68 4.19-8 4.2.08 4.2 3.17z"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <g>
            <path
              fill="#f01f1f"
              opacity={0.5}
              d="M257.8 130.95v16.55l25.35-14.63v-16.55l-25.35 14.63z"
            />
            <path
              fill="#fff"
              opacity={0.5}
              d="M278.75 130.43v10.81l16.56-9.56v-10.81l-16.56 9.56z"
            />
          </g>
          <g id="servicesbackground__news5">
            <path
              fill="#f01f1f"
              opacity={0.5}
              d="M118.75 93.31l46.16 26.81v54.99l-46.16-26.68V93.31z"
            />
            <path
              fill="#643838"
              opacity={0.6}
              d="M120.71 97.09l41.86 24.31v3.49l-41.86-24.19v-3.61zM131.64 111.47v2.06l-10.93-6.32v-2.09l10.93 6.35zM161.69 168.5v2.06l-10.93-6.32v-2.09l10.93 6.35zM128.5 114.47v2.07l-7.79-4.5v-2.09l7.79 4.52zM126.16 130.77c.28 11 7.24 22.62 15.54 26s14.8-2.87 14.52-13.87-7.25-22.62-15.55-26-14.8 2.87-14.51 13.87z"
            />
            <path
              d="M134.26 134.25c.12 4.66 3.07 9.59 6.59 11s6.28-1.22 6.16-5.88-3.07-9.6-6.6-11-6.27 1.21-6.15 5.88z"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <g id="servicesbackground__news3">
            <path
              d="M35.07 281.14c0 6.21 3.77 13.41 8.43 16.1s8.42-.17 8.42-6.37-3.77-13.41-8.42-16.1-8.43.17-8.43 6.37z"
              fill="red"
              opacity={0.5}
            />
            <path
              fill="#f01f1f"
              opacity={0.5}
              d="M0 238.49l82.3 47.52V214L0 166.49v72z"
            />
            <path
              fill="#fff"
              opacity={0.6}
              d="M18.83 242.8l-16.61-9.59v3.25l16.61 9.59v-3.25zM18.83 236.38l-16.61-9.59v3.25l16.61 9.59v-3.25zM18.83 229.66l-16.61-9.59v3.26l16.61 9.59v-3.26zM18.83 223.24l-16.61-9.59v3.26l16.61 9.59v-3.26zM18.83 216.53l-16.61-9.59v3.25l16.61 9.59v-3.25zM18.83 210.11l-16.61-9.59v3.25l16.61 9.59v-3.25zM18.83 203.39L2.22 193.8v3.26l16.61 9.59v-3.26zM18.83 196.97l-16.61-9.59v3.26l16.61 9.59v-3.26z"
            />
            <path
              fill="#643838"
              opacity={0.6}
              d="M18.83 181.74l-16.61-9.58v8.68l16.61 9.59v-8.69z"
            />
            <path
              fill="#691616"
              d="M79.26 216.85l-16.61-9.59v8.68l16.61 9.59v-8.68z"
            />
            <path
              fill="#fff"
              opacity={0.6}
              d="M72.84 225.29v8.68l6.42 3.71V229l-6.42-3.71zM72.84 238.27v8.68l6.42 3.71v-8.68l-6.42-3.71zM72.84 251.25v8.68l6.42 3.71v-8.68l-6.42-3.71zM72.84 264.23v8.68l6.42 3.71v-8.68l-6.42-3.71z"
            />
            <path
              fill="#691616"
              d="M55.03 202.85l-16.61-9.59v19.35l16.61 9.59v-19.35z"
            />
            <path
              d="M46.73 204.57c-1.29-.71-2.33.09-2.33 1.82a4.82 4.82 0 00.19 1.34l-8.24 5.62-16-9.22v1.62l16 9.26 8.73-6.01a4.69 4.69 0 001.65 1.85c1.31.76 2.37 0 2.37-1.79a5.66 5.66 0 00-2.37-4.49z"
              fill="#643838"
              opacity={0.6}
            />
            <path
              fill="#fff"
              opacity={0.5}
              d="M56.49 237.06l-16.61-9.59v19.35l16.61 9.59v-19.35z"
            />
            <path
              d="M48.19 237.56h-.06a2.46 2.46 0 00-1.33-.35l-8.28-15.39-.09-.17-18.1-10.53v1.62l17.05 9.93 8.17 15.19a3.46 3.46 0 00-.65 2.14 7.86 7.86 0 003.29 6.28c1.81 1.05 3.28-.06 3.28-2.48a7.88 7.88 0 00-3.28-6.24z"
              fill="#fff"
              opacity={0.6}
            />
            <path
              d="M46.73 206.42c-.53-.29-1 0-1 .75a2.38 2.38 0 001 1.88c.54.31 1 0 1-.74a2.35 2.35 0 00-1-1.89z"
              fill="#691616"
            />
            <path
              d="M61.33 224.5h-.09c-2.63-1.46-4.75.17-4.75 3.7 0 3.56 2.17 7.7 4.84 9.24s4.83-.1 4.83-3.66S64 226 61.33 224.5z"
              fill="#fff"
              opacity={0.6}
            />
            <path
              d="M48.19 240c-.79-.44-1.43.06-1.43 1.12a3.47 3.47 0 001.46 2.78c.8.47 1.45 0 1.45-1.1a3.49 3.49 0 00-1.48-2.8zM61.33 227.13c-1.56-.86-2.82.11-2.82 2.19a6.84 6.84 0 002.87 5.48c1.58.92 2.87-.05 2.87-2.16a6.86 6.86 0 00-2.92-5.51z"
              fill="#643838"
              opacity={0.6}
            />
            <path
              d="M60.58 236.89v28.39l-24.49-14.45.12-12L20.32 231v1.75l14.32 7.14-.12 11.87L62.14 268v-30.22a7.79 7.79 0 01-.81-.38c-.33-.18-.75-.51-.75-.51z"
              fill="#643838"
              opacity={0.6}
            />
            <path
              d="M88.43 325.13l-41.71-36.88v-.12a8.84 8.84 0 00-3-6.45v-18l-1.4-.81V281c-1.55-.37-2.69.82-2.69 3 0 2.63 1.6 5.69 3.57 6.82 1.46.85 2.71.4 3.26-1L88.36 327z"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <g>
            <path
              d="M474.13 267.57c0 6.2-3.77 13.41-8.42 16.09s-8.43-.16-8.43-6.37 3.78-13.41 8.43-16.09 8.42.16 8.42 6.37z"
              fill="red"
              opacity={0.5}
            />
            <path
              d="M429.36 303.34L462.49 274a.49.49 0 010-.12 8.79 8.79 0 013-6.44v-17l1.41-.82v17.08c1.54-.37 2.69.82 2.69 3 0 2.63-1.6 5.68-3.57 6.82-1.46.84-2.72.39-3.27-1l-35.22 30.88z"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <g>
            <g id="servicesbackground__news2">
              <path
                fill="#f01f1f"
                opacity={0.5}
                d="M296.27 0l-43.83 25.46v69.59l43.83-25.33V0z"
              />
              <path
                fill="#643838"
                opacity={0.6}
                d="M292.89 6.05l-20.77 12.07v20.61l20.77-12.01V6.05zM292.89 30.75l-20.77 12.06v20.61l20.77-12V30.75zM292.89 56.84l-20.77 12.07v9.34l20.77-12v-9.41z"
              />
              <path
                d="M266.21 28.63c-.08 3.11-2 6.39-4.39 7.33s-4.18-.81-4.1-3.91 2-6.39 4.39-7.33 4.18.81 4.1 3.91zM266.21 44.56c-.08 3.11-2 6.39-4.39 7.33s-4.18-.81-4.1-3.92 2-6.38 4.39-7.32 4.18.81 4.1 3.91z"
                fill="#691616"
              />
              <path
                d="M264 45.47a4 4 0 01-2.05 3.43c-1.1.44-2-.38-1.92-1.83a4 4 0 012-3.44c1.1-.44 1.97.37 1.97 1.84z"
                fill="#fff"
                opacity={0.5}
              />
              <path
                d="M266.21 60.49c-.08 3.1-2 6.38-4.39 7.33s-4.18-.81-4.1-3.92 2-6.38 4.39-7.32 4.18.81 4.1 3.91zM266.21 76.42c-.08 3.1-2 6.38-4.39 7.33s-4.18-.81-4.1-3.92 2-6.38 4.39-7.33 4.18.81 4.1 3.92z"
                fill="#691616"
              />
            </g>
            <path
              d="M279.81 95.73c0 4-2.44 8.68-5.45 10.42s-5.46-.15-5.46-4.15 2.44-8.69 5.46-10.43 5.45.14 5.45 4.16z"
              opacity={0.5}
              fill="url(#servicesbackground__linear-gradient-3)"
            />
            <path
              d="M321.08 89.42a7.5 7.5 0 01-3.12 6c-1.73 1-3.13-.06-3.13-2.36a7.47 7.47 0 013.13-6c1.72-1 3.12.06 3.12 2.36z"
              fill="#643838"
              opacity={0.6}
            />
            <path
              d="M318 89.27a3.19 3.19 0 00-1.15 1.38l-40.14 7.47a4.78 4.78 0 00.09-.63c0-1.44-.72-2.2-1.7-2V82l-1.41.81v13.45a6.09 6.09 0 00-1.7 4c0 1.77 1.08 2.59 2.41 1.82a5.08 5.08 0 001.91-2.45l40.16-7.48v.07c0 1.13.69 1.66 1.54 1.17a3.72 3.72 0 001.54-3c-.05-1.09-.74-1.61-1.55-1.12z"
              fill="#f01f1f"
              opacity={0.5}
            />
          </g>
          <g>
            <g id="servicesbackground__news4">
              <path
                fill="#f01f1f"
                opacity={0.5}
                d="M53.59 60.21l51.35 29.82v99.16l-51.35-29.68v-99.3z"
              />
              <path
                fill="#643838"
                opacity={0.6}
                d="M57.49 69.27l40.99 23.8v5.94L57.49 75.32v-6.05z"
              />
              <path
                fill="#fff"
                opacity={0.5}
                d="M77.55 92.75l20.93 12.15v2.28l-20.93-12.1v-2.33zM81.57 100.2l16.91 9.81v2.28l-16.91-9.77v-2.32zM81.57 105.26l16.91 9.82v2.28l-16.91-9.77v-2.33zM77.55 117.48l20.93 12.15v2.28l-20.93-12.09v-2.34zM81.57 124.93l16.91 9.82v2.27l-16.91-9.77v-2.32zM81.57 130l16.91 9.81v2.28l-16.91-9.77V130zM77.55 142.18l20.93 12.15v2.28l-20.93-12.1v-2.33zM81.57 149.63l16.91 9.81v2.28l-16.91-9.77v-2.32zM81.57 154.69l16.91 9.82v2.27l-16.91-9.77v-2.32z"
              />
              <path
                fill="#691616"
                d="M75.6 91.58v19.46l-16.46-9.51V82.02l16.46 9.56zM75.6 115.81v19.45l-16.46-9.51v-19.51l16.46 9.57zM75.6 140.17v19.46l-16.46-9.52v-19.5l16.46 9.56zM75.6 164.39v3.77l-16.46-9.51v-3.82l16.46 9.56z"
              />
            </g>
            <path
              d="M92.42 205.62c0 4.72 2.87 10.2 6.41 12.25s6.41-.13 6.41-4.85-2.87-10.2-6.41-12.25-6.41.13-6.41 4.85zM165.26 247.42c0 2.63 1.6 5.69 3.57 6.82s3.57-.06 3.57-2.7-1.6-5.68-3.57-6.82-3.57.07-3.57 2.7z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              d="M168.83 247a1.08 1.08 0 00-1.66.43l-64.79-36a8.73 8.73 0 00-3.2-6.32v-19.25l-1.41-.81v19.35c-1.45-.23-2.51.94-2.51 3.07 0 2.64 1.6 5.69 3.57 6.83a2.12 2.12 0 003.41-1.44l64.77 36a4.45 4.45 0 001.82 3.09c1 .6 1.89 0 1.89-1.43a4.55 4.55 0 00-1.89-3.52z"
              fill="#643838"
              opacity={0.6}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;

